import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import WishListBtn from "../components/WishListBtn";
import api from "../components/api";
import "./ProductDetailsPage.css";
import PostModel from "../components/PostModel";
import { FollowProvider } from "../context/FollowContext";
import CuruChatsPost from "../components/CuruChatsPost";

export default function PostPage() {
  const location = useLocation();
  const [productDetails, setProductDetails] = useState(null);
  const [isPostModelOpen, setIsPostModelOpen] = useState(false);
  const [preSelectedCategory, setPreSelectedCategory] =
    useState("Ask the community");
  const [preSelectedProduct, setPreSelectedProduct] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const navigate = useNavigate();

  const fetchProductDetails = async (id) => {
    try {
      const response = await api.get(`/products/${id}`);
      const productDetails = response.data;
      setProductDetails(productDetails);
      console.log(productDetails);
      return productDetails;
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch user profile data
  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserProfile(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(null);
      return null;
    }
  };

  useEffect(() => {
    fetchUserProfile();
    fetchProductDetails(location.state.productDetails.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!productDetails) {
    // return <div>Error: No product details available.</div>;
    return <div></div>;
  }

  const handleProfileClick = (user) => {
    if (!user || !user.id) return;
    navigate(`/profile/${user.id}`, { state: { user } });
  };

  return (
    <>
      <div className="container">
        <FollowProvider>
          <div className="row w-100">
            {/* product-image */}
            <div className="col-12 col-md-6 d-flex flex-column">
              <div className="product-image module1 mt-5 position-relative">
                <Link to={`/product-details/${productDetails.id}`}>
                  <img
                    src={
                      productDetails.image
                        ? productDetails.image
                        : "https://placehold.co/260x360/FFF/c2c2c2?text=No+Picture"
                    }
                    alt={productDetails.name}
                    className="img-fluid rounded mt-3 object-fit-cover"
                  />
                </Link>
                <span className="wishlist-wrapper">
                  <WishListBtn
                    isAdd={productDetails.wishlist}
                    productId={productDetails.id}
                    onSuccess={fetchProductDetails}
                  />
                </span>
                <span
                  className="ask-community-wrapper"
                  onClick={() => {
                    setPreSelectedCategory("Ask the community");
                    setPreSelectedProduct(productDetails);
                    setIsPostModelOpen(true);
                  }}
                >
                  Ask community about this product
                </span>
              </div>
            </div>

            {/* Posts */}
            <div className="col-12 col-md-6 el d-flex flex-column">
              <div className="what-people-are-saying mt-5">
                <h4 className="section-title mb-4">What People Are Saying</h4>
                {productDetails.posts.map((post) => (
                  <CuruChatsPost
                    key={post.id}
                    post={post}
                    onProfileClick={handleProfileClick}
                    onDeleteSuccess={() => {
                      // remove from local productDetails.posts to reflect instantly
                      setProductDetails((prev) => ({
                        ...prev,
                        posts: (prev.posts || []).filter((p) => p.id !== post.id),
                      }));
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </FollowProvider>
      </div>
      {isPostModelOpen && (
        <PostModel
          profile={userProfile}
          isOpen={isPostModelOpen}
          onClose={() => setIsPostModelOpen(false)}
          preSelectedCategory={preSelectedCategory}
          preSelectedProduct={preSelectedProduct}
        />
      )}
    </>
  );
}
